import React, { Component } from "react";
import Sidebar from "../component/Sidebar";
import "../assets/css/MainContainer.css";
import logo from "../assets/image/SaxonyCrest.png";
//import search from "../assets/image/search-icon.png";
import Dashboard from "../screens/Dashboard";
import RoutineScreen from "../screens/RoutineScreen";
import FileScreen from "../screens/FileScreen";
import SettingScreen from "../screens/SettingScreen";
import user from "../assets/image/fleissig.jpeg";
import { connect } from "react-redux";
import { setCurrentCase } from "../actions/cases";
import Modal from "react-responsive-modal";
import FunktionScreen from "../screens/FunktionScreen";
import OverviewScreen from "../screens/OverviewScreen";
import ArbeitslisteScreen from "../screens/ArbeitslisteScreen";
import BearbeitungsScreen from "../screens/BearbeitungsScreen";

class AppContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentScreen: 0,
      kind: -1,
      case: -1,
      sidebar: true,
      modal: false
    };
  }

  switchScreen(id) {
    this.setState({ currentScreen: id });
  }

  switchKind(kind) {
    this.setState({ kind: kind });
  }

  switchCase(caseId) {
    this.setState({ case: caseId });
  }

  renderScreen() {
    switch (this.state.currentScreen) {
      case 0:
        return <FunktionScreen switchScreen={this.switchScreen.bind(this)} />;
      case 1:
        return (
          <OverviewScreen
            switchScreen={this.switchScreen.bind(this)}
            switchKind={this.switchKind.bind(this)}
          />
        );
      case 2:
        return (
          <ArbeitslisteScreen
            kind={this.state.kind}
            switchScreen={this.switchScreen.bind(this)}
            switchCase={this.switchCase.bind(this)}
          />
        );
      case 3:
        return (
          <BearbeitungsScreen kind={this.state.kind} case={this.state.case} />
        );
      default:
        return <Dashboard />;
    }
  }

  calculateTotalCases() {
    let cases = 0;
    cases += this.props.cases[0].length;
    cases += this.props.cases[1].length;
    cases += this.props.cases[2].length;
    cases += this.props.cases[3].length;
    cases += this.props.cases[4].length;
    return cases;
  }

  renderHeader() {
    return (
      <div>
        <div className="logo">
          <img src={logo} className="crest" alt="logimg" />
          <p>eRechnungsworkflow</p>
          <div className="verticalLine"></div>
          {/*<img src={search} className="searchIcon" />
         <input type="text" name="fname" placeholder="Suche" />*/}
        </div>
        <div>
          <div className="user">
            <img
              onClick={() => this.setState({ modal: true })}
              src={user}
              alt="user"
            />
            <p style={{ fontWeight: "bold" }}>Bewirtschafter:</p>
            <p>M. Müller</p>
          </div>
          <div className="side">
            <Sidebar
              cases={this.calculateTotalCases()}
              logout={this.props.logout}
              switchScreen={this.switchScreen.bind(this)}
              activeScreen={this.state.currentScreen}
              toggle={() => this.toggleSidebar()}
              toggleState={this.state.sidebar}
            />
          </div>
        </div>
      </div>
    );
  }

  switchProgress(index) {
    if (index > this.state.currentScreen) return;
    this.setState({ currentScreen: index });
  }

  getProgressClass(index) {
    let className = "progressItem";
    if (index === 0) className += " first";
    if (index < this.state.currentScreen) className += " past";
    if (index === this.state.currentScreen) className += " active";
    return className;
  }

  renderProgress() {
    return (
      <div className="progressRow">
        <div
          className={this.getProgressClass(0)}
          onClick={this.switchProgress.bind(this, 0)}
        >
          <p>Funktion</p>
        </div>
        <div
          className={this.getProgressClass(1)}
          onClick={this.switchProgress.bind(this, 1)}
        >
          <p>Übersicht</p>
        </div>
        <div
          className={this.getProgressClass(2)}
          onClick={this.switchProgress.bind(this, 2)}
        >
          <p>Arbeitsliste</p>
        </div>
        <div
          className={this.getProgressClass(3)}
          onClick={this.switchProgress.bind(this, 3)}
        >
          <p>Bearbeitung</p>
        </div>
      </div>
    );
  }

  toggleSidebar() {
    this.setState({ sidebar: !this.state.sidebar });
  }

  isSidebarSmall() {
    return this.state.sidebar ? "" : " small";
  }

  render() {
    return (
      <div className="container">
        <div className="header">{this.renderHeader()}</div>
        {this.renderProgress()}
        <div className={"screenContainer" + this.isSidebarSmall()}>
          <div className="extraContainer">
            <div className="screen">{this.renderScreen()}</div>
          </div>
        </div>
        <Modal
          open={this.state.modal}
          onClose={() => this.setState({ modal: false })}
          center
        >
          <h2
            style={{
              marginLeft: "20px",
              marginRight: "40px",
              marginBottom: "10px"
            }}
          >
            Datenbank Zurücksetzen?
          </h2>
          <button
            style={{ marginLeft: "20px" }}
            onClick={() => {
              sessionStorage.removeItem("user");
              window.location.reload();
            }}
          >
            Ja
          </button>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    cases: state.cases
  };
};

const mapDispatchToProps = dispatch => ({
  setCurrentCase: curCase => {
    dispatch(setCurrentCase(curCase));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AppContainer);



// WEBPACK FOOTER //
// ./src/container/MainContainer.js